'use client'

import { IconDownload, IconHandFinger, IconMenu } from '@tabler/icons-react'
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerTrigger,
  ScrollArea,
  Separator,
} from 'ui'
import { usePDFStore } from '../../stores/pdf.store'
import { PDF_CONTROLS_PORTAL_ID } from '../PDFViewer'
import { TunnelRat } from '../TunnelRat'
import { useCallback } from 'react'

export const SigningInfo = () => {
  const fields = usePDFStore((state) => state.fields)
  const documents = usePDFStore((state) => state.documents)
  const isLargeDevice = usePDFStore((state) => state.isLargeDevice)

  const onDownloadFile = useCallback(
    async (presignedURL: string, filename: string) => {
      const response = await fetch(presignedURL)
      const blob = await response.blob()
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    []
  )

  const onDownloadDocuments = useCallback(async () => {
    for (const document of documents) {
      await onDownloadFile(document.file.url, document.file.original_name)
    }
  }, [documents])

  const content = (
    <div className='font-medium space-y-5'>
      <div>
        <div className='flex flex-row items-center space-x-2 px-4 py-2 h-16'>
          <p className='font-medium'>Acciones</p>
        </div>
        <Separator />
        <div>
          <div className='flex flex-col bg-purple-300 px-4 py-2 h-16 items-start justify-center'>
            <div className='text-white flex flex-row space-x-2 items-center'>
              <IconHandFinger className='w-4 h-4' />
              <span>{fields.length} campos a completar</span>
            </div>
          </div>

          <button
            onClick={onDownloadDocuments}
            className='text-white w-full bg-gray-300 flex flex-row space-x-2 items-center hover:bg-gray-500 px-4 py-2 h-16 transition-all'
          >
            <IconDownload className='w-4 h-4' />
            <span>Descargar documentos</span>
          </button>
        </div>
      </div>
    </div>
  )

  if (!isLargeDevice) {
    return (
      <TunnelRat tunnelId={PDF_CONTROLS_PORTAL_ID}>
        <div className='absolute left-0 h-full flex items-center justify-center top-0 p-4'>
          <Drawer>
            <DrawerTrigger>
              <IconMenu className='w-4 h-4' />
            </DrawerTrigger>
            <DrawerContent>{content}</DrawerContent>
          </Drawer>
        </div>
      </TunnelRat>
    )
  }

  return (
    <ScrollArea className='overflow-y-auto [&>div>div]:!block shrink-0'>
      {content}
    </ScrollArea>
  )
}
